@if (incomeTaxEntity$ | async) {
  <form [formGroup]="formGroup">
    <div formArrayName="ontvangenAlimentatie">
      @for (item of opbrengsten.controls; track item; let i = $index) {
        <div [formGroupName]="i" class="row" style="--bs-gutter-x: 0.5rem;">
          <div class="col-auto row" style="--bs-gutter-x: 0.5rem;">
            <snelstart-ui-text-form-control [label]="i === 0 ? 'Omschrijving alimentatie' : ''"
                                            class="col-auto custom-input-250"
                                            formControlName="omschrijving"
                                            id="omschrijving"
            >
            </snelstart-ui-text-form-control>
            <snelstart-ui-number-form-control [decimals]="0"
                                              [label]="i === 0 ? 'Bedrag' : ''"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="bedrag"
                                              id="bedragRow"
                                              prefix="€"

            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-button (click)="verwijderRijOpbrengsten(i)"
                                 [class]="i === 0 ? 'firstrowbutton' : ''"
                                 class="col-auto"
                                 icon="trash"
                                 id="buttonDeleteKosten"
                                 size="medium"
                                 type="secondary"
            >
            </snelstart-ui-button>
          </div>
        </div>
      }
    </div>

    <snelstart-ui-button (click)="addRijOpbrengsten()" class="snelstart-ui-button pb-3" icon="plus"
                         type="link">Ontvangen partneralimentatie toevoegen
    </snelstart-ui-button>

    <div formArrayName="aftrekbareKostenAlimentatie">
      @for (item of kosten.controls; track item; let i = $index) {
        <div [formGroupName]="i" class="row" style="--bs-gutter-x: 0.5rem;">
          <div class="col-auto row" style="--bs-gutter-x: 0.5rem;">
            <snelstart-ui-text-form-control [label]="i === 0 ? 'Omschrijving kosten' : ''"
                                            class="col-auto custom-input-250"
                                            formControlName="omschrijving"
            >
            </snelstart-ui-text-form-control>
            <snelstart-ui-number-form-control [decimals]="0"
                                              [label]="i === 0 ? 'Bedrag' : ''"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="bedrag"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-button (click)="verwijderRijKosten(i)"
                                 [class]="i === 0 ? 'firstrowbutton' : ''"
                                 class="col-auto"
                                 icon="trash"
                                 size="medium"
                                 type="secondary"
            >
            </snelstart-ui-button>
          </div>
        </div>
      }
    </div>
    <snelstart-ui-button (click)="addRijKosten()" class="snelstart-ui-button" icon="plus"
                         type="link">Kosten partneralimentatie toevoegen
    </snelstart-ui-button>
  </form>
}
